import React, { useEffect, useState } from "react";
import "../style/VizzySmartCallAssistant.css";

const VizzySmartCallAssistant = () => {
  const [iframeHeight, setIframeHeight] = useState("100vh");

  useEffect(() => {
    // Set page title
    document.title = "Vizzy Smart Call Assistant - ModalX";

    // Adjust iframe height based on viewport
    const updateHeight = () => {
      const viewportHeight = window.innerHeight;
      setIframeHeight(`${viewportHeight}px`);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
      // Reset title when component unmounts
      document.title = "ModalX";
    };
  }, []);

  return (
    <div className="vizzy-smart-call-assistant-container">
      <iframe
        src="https://v0-vi-sim-chatbot-shell.vercel.app/"
        title="Vizzy Smart Call Assistant"
        className="vizzy-smart-call-assistant-iframe"
        style={{ height: iframeHeight }}
        frameBorder="0"
        allow="microphone; camera; clipboard-write; clipboard-read"
        allowFullScreen
      />
    </div>
  );
};

export default VizzySmartCallAssistant;